// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3bYi7","large":"styles_large__2pjiz"};